import { buildApiUrl } from "./Static";

export function slugConfirmsDelete(input, slug) {
  return (
    String(input || "")
      .trim()
      .toLowerCase() ===
    String(slug || "")
      .trim()
      .toLowerCase()
  );
}

export function materialDeleteUrl(id) {
  const safeId = encodeURIComponent(String(id || "").trim());
  return buildApiUrl(`/material/delete/${safeId}`);
}

export function materialDeleteErrorMessage(error) {
  const status = error?.response?.status;
  const data = error?.response?.data;
  if (status === 401 || status === 403) {
    return "Sign in as VendorAdmin to delete a material.";
  }
  return data?.msg || data?.message || "Unable to delete this material.";
}

export function collectionWithoutMaterial(collection, materialId) {
  const id = String(materialId ?? "");
  return (Array.isArray(collection) ? collection : []).filter(
    (item) => String(item) !== id,
  );
}
